import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { CiCamera } from "react-icons/ci";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { AiFillCheckCircle } from "react-icons/ai";
import uploadFiles from "../common/UploadFiles";
import { update_seller_profile } from "../../hook/useapi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const BannerProfile = ({ profiledate }) => {
  console.log(profiledate);

  const [backgroundprofile, setBackgroundprofile] = useState(
    "/image/backgroundprofile.png"
  );
  const [profilePreview, setProfilePreview] = useState("/image/profilepic.png");
  const [coverFile, setCoverFile] = useState(null);

  useEffect(() => {
    if (profiledate?.cover_image?.url) {
      setBackgroundprofile(profiledate.cover_image.url);
    }
    if (profiledate?.profile_image?.url) {
      setProfilePreview(profiledate.profile_image.url);
    }
  }, [profiledate]);

  const handleImageUpload = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ show preview
    const previewUrl = URL.createObjectURL(file);
    if (fieldName === "cover_image") {
      setBackgroundprofile(previewUrl);
    } else if (fieldName === "profile_image") {
      setProfilePreview(previewUrl);
    }

    try {
      // ✅ upload file
      const uploaded = await uploadFiles([file]);
      const imageData = {
        url: uploaded[0].url,
        media_type: file.type,
      };

      // ✅ send dynamic body
      const body = {
        seller_id: String(profiledate?.id),
        [fieldName]: imageData,
      };

      const resp = await axios.post(
        `${API_BASE_URL}/seller/update-seller-profile`,
        body,
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );
      console.log(`${fieldName} updated:`, resp);

      toast.success(
        `${
          fieldName === "cover_image" ? "Cover" : "Profile"
        } image updated successfully!`
      );
    } catch (error) {
      console.error(`Error uploading ${fieldName}:`, error);
      toast.error(`Failed to upload ${fieldName.replace("_", " ")}!`);
    }
  };
  return (
    <div>
      <div className="relative rounded-lg py-4">
        {/* Cover Image Section */}
        <div className="w-full h-[100px] sm:h-[320px] rounded-lg overflow-hidden relative group">
          <input
            type="file"
            accept="image/*"
            id="cover-upload"
            className="hidden"
            onChange={(e) => handleImageUpload(e, "cover_image")}
          />

          <label className="cursor-pointer block">
            <img
              src={backgroundprofile}
              alt="Cover"
              className="w-full h-[100px] sm:h-[280px] object-cover group-hover:opacity-80 transition"
            />
          </label>

          <label
            htmlFor="cover-upload"
            className="absolute top-0 right-10 bg-white px-2 py-2 text-sm rounded-b-2xl shadow cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <FaEdit className="text-lg" />
              Edit Cover
            </span>
          </label>
        </div>

        {/* Profile Image Section */}
        <div className="absolute -bottom-4 left-3 sm:-bottom-9 sm:left-6">
          <div className="flex items-center">
            <div className="relative  w-[70px] h-[70px]  sm:w-[170px] sm:h-[170px] overflow-hidden group ">
              <input
                type="file"
                accept="image/*"
                id="profile-upload"
                className="hidden"
                onChange={(e) => handleImageUpload(e, "profile_image")}
              />
              <label htmlFor="profile-upload" className="cursor-pointer block">
                <img
                  src={profilePreview}
                  alt="Profile"
                  className="w-[70px] h-[70px] sm:w-full sm:h-full object-cover group-hover:opacity-80 transition"
                />
              </label>
              <div className="absolute top-[50%] right-0 bg-transparent text-xs px-1 py-1 rounded shadow ">
                <CiCamera className="text-xl text-white" />
              </div>
            </div>
            <div className="mt-20 ml-7">
              <div className=" flex items-center gap-3">
                <p className="text-lg font-semibold">
{profiledate?.name || "Unknown User"}                </p>
                <p className="flex gap-1 items-center text-[10px] text-white bg-yellow-400 py-1 px-[7px] rounded-xl">
                  <RiVerifiedBadgeFill className="text-[17px]" />
                  Pending
                </p>
              </div>

              <p className="text-[#BE1F2E] font-[Poppins] font-medium italic text-[14px] py-2 leading-[100%] tracking-[0%]">
                *Your details have been submitted for verification
              </p>

              <div className="flex gap-1">
                <div>
                  <p className=" rounded-xl flex">
                    <AiFillCheckCircle className="text-green-700 border-2 text-[25px] border-white" />
                    KYC
                  </p>
                </div>
                <div>
                  <p>---------------</p>
                </div>
                <div>
                  {" "}
                  <p className=" rounded-xl flex">
                    <AiFillCheckCircle className="text-gray-300 border-2 text-[25px] border-white" />
                    Store Review
                  </p>
                </div>
                <div>
                  <p>---------------</p>
                </div>
                <div>
                  {" "}
                  <p className=" rounded-xl flex">
                    <AiFillCheckCircle className="text-gray-300 border-2 text-[25px] border-white" />
                    Approval
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerProfile;
